import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-cancel-icon',
  imports: [],
  templateUrl: './cancel-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './cancel-icon.component.scss',
})
export class CancelIconComponent {
  @Input() public size = 8;
}
